// Report and block actions shared by the web marketplace pages.
export const reportReasons = [
  ['spam', 'Spam'],
  ['offensive', 'Offensive or abusive'],
  ['scam', 'Scam or fraud'],
  ['unsafe', 'Unsafe'],
  ['other', 'Something else'],
];
export const maxReportDetails = 2000;

// Feed item kinds on the web ('job' | 'home_job' | 'tender') to report targets.
export const listingReportTarget = { job: 'commercial_job', home_job: 'home_job', tender: 'private_tender' };
export const bidReportTarget = { job: 'job_proposal', home_job: 'home_job_proposal', tender: 'private_tender_response' };

function check(error) { if (error) throw new Error(error.message || 'That did not work. Please try again.'); }

export async function reportContent(client, { targetType, targetId, reason, details = '' }) {
  const clean = String(details).trim();
  if (!reason) throw new Error('Choose a reason for your report.');
  if (clean.length > maxReportDetails) throw new Error(`Please keep details under ${maxReportDetails} characters.`);
  const { error } = await client.from('content_reports').insert({ target_type: targetType, target_id: targetId, reason, details: clean });
  check(error);
}

/** Supplier blocks whoever posted a listing: the person behind a home job, or the buyer organisation behind a job or tender. */
export async function blockListingOwner(client, kind, jobId) {
  const { error } = kind === 'home_job'
    ? await client.rpc('block_home_job_poster', { job_uuid: jobId })
    : await client.rpc('block_listing_buyer', { p_kind: kind, p_job_id: jobId });
  check(error);
}

/** Job owner blocks the supplier company behind a bid. */
export async function blockBidSupplier(client, kind, bidId) {
  const { error } = await client.rpc('block_bid_supplier', { p_kind: kind, p_bid_id: bidId });
  check(error);
}

export async function listBlocks(client) {
  const [people, organizations] = await Promise.all([
    client.from('user_blocks').select('blocked_id,created_at').order('created_at', { ascending: false }),
    client.rpc('list_my_organization_blocks'),
  ]);
  check(people.error); check(organizations.error);
  return {
    people: (people.data || []).map((row, index) => ({ key: `person:${row.blocked_id}`, id: row.blocked_id, type: 'person', title: `Blocked person ${index + 1}`, createdAt: row.created_at, canUnblock: true })),
    organizations: (Array.isArray(organizations.data) ? organizations.data : []).map((row, index) => ({
      key: `organisation:${row.id}`, id: row.id, type: 'organisation',
      title: row.blocked_organization_name || `Blocked organisation ${index + 1}`,
      byCompany: row.blocked_by_company ? (row.company_name || 'your company') : '',
      createdAt: row.created_at, canUnblock: Boolean(row.can_unblock),
    })),
  };
}

export async function unblockEntry(client, entry) {
  const { error } = entry.type === 'person'
    ? await client.from('user_blocks').delete().eq('blocked_id', entry.id)
    : await client.rpc('unblock_organization', { p_block_id: entry.id });
  check(error);
}
